module.exports = __webpack_public_path__ + "img/Mid-AutumnFestival.a9d18537.png";